import {compose} from "redux"
import React from "react";
import PropTypes from "prop-types";
import DeleteIcon from '@material-ui/icons/Delete';
import { withStyles,Paper,Input,Dialog,DialogActions,DialogContent,DialogContentText,Tooltip,DialogTitle,Divider,IconButton,Button as MaterialButton} from "@material-ui/core";
import {Button,CustomInput,MemberList,LoadingSpinner} from "../../components"
import { withFirestore,firestoreConnect,isLoaded} from 'react-redux-firebase'
import { connect } from 'react-redux'
import _ from "lodash"
import {Button as FabButton} from '@material-ui/core';
import EditIcon from "@material-ui/icons/Edit"


var organisationId;

class ViewOrganisation extends React.Component {

    state={
          dialogOpen:false,
          dialogDeleteOpen:false,
          inviteeEmail:"",
          isLoading:false,
          surveyReferences:0
    }

    constructor(props){
        super(props)
        organisationId = this.props.route.match.params.id
    }

    navEditOrganisation=(orgId)=>{
        const {history} = this.props
        history.push(`/organisation/${orgId}/edit`)
    }

    addMember=()=> {
        const {firestore} = this.props;
        const {inviteeEmail} = this.state
        this.setState({isLoading:true})
        firestore.get({collection: "users", where: [['email', '==', inviteeEmail],['isDashboardUser','==',true]]}).then((result) => {

            if(result.docs.length>0){
                let userId =result.docs[0].id;
                let inviteUserObject = {}
                inviteUserObject[`members.${userId}`] = true
                return firestore.update({collection:"organisations",doc:organisationId},inviteUserObject)
            }
            else{
                let inviteUserObject={}
                inviteUserObject[organisationId] =true;
                return firestore.set({collection:"invitedUsers",doc:inviteeEmail},{invitedToOrganisations:inviteUserObject},{merge:true})
            }
        }).finally(()=>{
            this.setState({isLoading:false})
            this.setState({dialogOpen:false})
        })

    }

    cancelInvite=(email)=>{
        const {firestore} = this.props;
        firestore.update({collection:"invitedUsers",doc:`${email}`},{[`invitedToOrganisations.${organisationId}`]: firestore.FieldValue.delete()
        })
    }

    removeMember=(userId)=>{
        const {firestore} = this.props
        firestore.update({collection:"organisations",doc:`${organisationId}`},{[`members.${userId}`]: firestore.FieldValue.delete()
        })
    }

    openAddMemberModal = () => {
        this.setState({ dialogOpen: true });
    };

    openDeleteModal = () => {
        this.setState({ dialogDeleteOpen: true });
    };
    openDeleteModal = () => {
        this.setState({ dialogDeleteOpen: true });
    };

    handleClose = () => {
        this.setState({ dialogOpen: false });
        this.setState({ dialogDeleteOpen: false });
    };

    deleteEmptyOrganisation=()=>{

        const {firestore,organisation,history,users,invitedUsers} = this.props

        // dont delete if attached to survey
        if(this.state.surveyReferences == 0){
           
            // clean invitedUser
            _.map(invitedUsers,(invitedUser,key)=>{
                if(invitedUser){
                    firestore.update({collection:"invitedUsers",doc:`${invitedUser.id}`},{[`invitedToOrganisations.${organisationId}`]: firestore.FieldValue.delete()
                    })
                }
            })

             // clean selected ORGANISATION
             _.map(users,(user,key)=>{
                if(user&&user.selectedOrganisation == organisationId){
                    firestore.update({collection:"users",doc:`${key}`,},{selectedOrganisation:firestore.FieldValue.delete()})
                }
            })

            // delete organisation
            firestore.delete({collection:"organisations",doc:organisationId})
            this.setState({isLoading:false})
            this.setState({dialogDeleteOpen:false})
            history.push(`/organisations`)
        }
    }

    componentWillMount(){
        const {surveys} = this.props

        _.map(surveys, (survey,key)=>{
            if(survey.organisationID == organisationId){
                this.setState({ surveyReferences: this.state.surveyReferences + 1});
            }
        })
    }


    render(){

        const {classes,organisation,invitedUsers,users,surveys,userAnswers} = this.props
        const {isLoading} = this.state

        return(

            <div className={classes.root}>
                <Paper className={classes.container}>
                    <div className={classes.header}>
                        {this.state.surveyReferences == 0 ?
                            <Tooltip title="Delete Organisation" placement="bottom"  classes={{ tooltip: classes.lightTooltip }}>
                                <DeleteIcon style={{paddingTop: 15,marginRight:20,color:"rgba(0, 0, 0, 0.4)",cursor: "pointer",float:"right"}} onClick={this.openDeleteModal}>Delete</DeleteIcon>
                            </Tooltip>
                        :<div style={{paddingTop: 15,marginRight:20}}/>}
                    </div>

                    <Input
                        value={organisation&&organisation.name?organisation.name:"Untitled Organisation"}
                        //defaultValue={organisation&&organisation.name?organisation.name:"Untitled Organisation"}
                        className={classes.organisationHeaderInput}
                        disabled={true}
                    />

                    <CustomInput
                        value={organisation&&organisation.description?organisation.description:""}
                        labelText="Organisation Description"
                        inputProps={{
                            defaultValue:organisation&&organisation.description,
                            disabled:true
                        }}
                        formControlProps={{
                            fullWidth: true
                        }}
                    />

                    <CustomInput
                        value={organisation&&organisation.avatarUrl?organisation.avatarUrl:""}
                        labelText="Avatar URL"
                        inputProps={{
                            defaultValue:organisation&&organisation.avatarUrl,
                            disabled:true
                        }}

                        formControlProps={{
                            fullWidth: true
                        }}
                    />

                    <div className={classes.memberControls}>
                        <Button color="primary" onClick={this.openAddMemberModal}>Add User</Button>
                    </div>
                    <h3 style={{color:"rgb(85, 85, 85)",fontSize: 15,fontWeight:600}}>Members</h3> 
                        <Divider/>   
                    <MemberList users={users?users:[]} members={organisation&&organisation.members} removeMember={this.removeMember} cancelInvite={this.cancelInvite} invitedUsers={invitedUsers} />

                </Paper>

<FabButton variant="fab" className={classes.fab} color="primary" onClick={()=>{this.navEditOrganisation(organisation.id)}} aria-label="Edit Organisation">
<EditIcon/>
</FabButton>


                <Dialog
                    open={this.state.dialogOpen}
                    onClose={this.handleClose}
                    aria-labelledby="addMember-dialog-title"
                >
                    <DialogTitle id="addMember-dialog-title">Invite User</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Enter the email address of the user you would like to invite to your organisation.
                        </DialogContentText>

                        <CustomInput
                            labelText="Email Address"
                            inputProps={{
                                type:"email",
                                autoFocus:true,
                                onChange:(event)=>{this.setState({inviteeEmail:event.target.value})}

                            }}

                            formControlProps={{
                                fullWidth: true
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <MaterialButton onClick={this.handleClose} color="primary">
                            Cancel
                        </MaterialButton>
                            <MaterialButton onClick={this.addMember} color="primary">
                                {!isLoading ? "Invite": <LoadingSpinner/>}
                            </MaterialButton>:
                    </DialogActions>
                </Dialog>

                <Dialog
                open={this.state.dialogDeleteOpen}
                onClose={this.handleClose}
                aria-labelledby="delete-dialog-title"
            >
                <DialogTitle id="delete-dialog-title">Delete Organisation</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this organisation.
                    </DialogContentText>

                </DialogContent>
                <DialogActions>
                    <MaterialButton onClick={this.handleClose} color="primary">
                        Cancel
                    </MaterialButton>
                        <MaterialButton onClick={this.deleteEmptyOrganisation} color="primary">
                            {!isLoading ? "Delete": <LoadingSpinner/>}
                        </MaterialButton>:
                </DialogActions>
            </Dialog>

            </div>

        )
    }
}

const styles ={
    lightTooltip: {
        background: "white",
        fontSize: 12,
        color:"rgba(0, 0, 0, 0.87)",
        boxShadow:"0 1px 2px 0 rgba(60,64,67,0.3), 0 1px 3px 1px rgba(60,64,67,0.15)"
      },
    root:{
        display:"flex",
        justifyContent:"center",
        marginTop:20
    },
    container:{
        width:"50%",
        minWidth:300,
        padding:60,
        paddingTop:25
    },
    header:{
        display:"flex",
        justifyContent:"flex-end"

    },
    organisationHeaderInput:{
        fontSize:40,
        width:"100%",
    },
    memberControls:{
        display:"flex",
        justifyContent:"flex-end"
    },
    fab:{
        position: 'absolute',
        bottom: "55%",
        right: "8%"
    }


}

export default compose(
    withFirestore,
    withStyles(styles),
    firestoreConnect((props) =>{
        return([{
            collection: "users",
        }])
    }),
    connect((state)=>{
        return {
            users: state.firestore.data.users

        }
    })
)(ViewOrganisation)


// WEBPACK FOOTER //
// ./src/views/Organisations/ViewOrganisation.jsx